<template>
    <v-textarea
        :label="label"
        v-bind:value="value"
        v-bind="$attrs"
        v-on:input="$emit('input', $event)"
        :color="ada.blue"
        :rows="rows ? rows : 10"
        :disabled="disabled"
    ></v-textarea>
</template>

<script>
import ada from '../../scss/ada_colors.scss';

export default {
    name: "Textarea",
    props: ['label', 'value', 'rows', 'disabled'],
    data: () => {
        return {ada}
    }
}
</script>

<style scoped>

</style>